// Start Case Is A Cool Thing
const startCaseFilter = () => {
  return (string) => {
    return _.startCase(string);
  };
};

// Title Case Is Also a Cool Thing
const titleCaseFilter = () => {
  return (string) => {
    if (!string) return '';

    const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
    string = string.toLowerCase();

    return string.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, (match, index, title) => {
      if (
        index > 0 &&
        index + match.length !== title.length &&
        match.search(smallWords) > -1 &&
        title.charAt(index - 2) !== ':' &&
        (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
        title.charAt(index - 1).search(/[^\s-]/) < 0
      ) {
        return match.toLowerCase();
      }

      if (match.substr(1).search(/[A-Z]|\../) > -1) {
        return match;
      }

      return match.charAt(0).toUpperCase() + match.substr(1);
    });
  };
};

// Returns the length of a string.
const stringLengthFilter = () => {
  return (string) => {
    return string == null ? 0 : string.length;
  };
};

export default {
  startCaseFilter,
  titleCaseFilter,
  stringLengthFilter,
};



// WEBPACK FOOTER //
// ./src/filters/stringFilters.js